import React from 'react';
import PropTypes from 'prop-types';
import {Dialog, DialogActions} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";

const UploadFailedDialog = ({open, okClicked}) => {
    const {t} = useTranslation('common');
    const {t: tUpload} = useTranslation('uploadForm');
    return (
        <Dialog open={open}>
            <DialogTitle id="alert-dialog-title">{tUpload('Uploading Failed Title')}</DialogTitle>
            <DialogContent dividers>
                {tUpload('Uploading Failed')}
            </DialogContent>
            <DialogActions>
                <Button onClick={okClicked} color="secondary">
                    {t('OK Button')}
                </Button>
            </DialogActions>
        </Dialog>);
};

UploadFailedDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    okClicked: PropTypes.func.isRequired
};

export default UploadFailedDialog;
